/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const apidata = $root.apidata = (() => {

    /**
     * Namespace apidata.
     * @exports apidata
     * @namespace
     */
    const apidata = {};

    apidata.prices = (function() {

        /**
         * Namespace prices.
         * @memberof apidata
         * @namespace
         */
        const prices = {};

        prices.Tick = (function() {

            /**
             * Properties of a Tick.
             * @memberof apidata.prices
             * @interface ITick
             * @property {string|null} [entityId] Tick entityId
             * @property {string|null} [exchange] Tick exchange
             * @property {string|null} [segment] Tick segment
             * @property {number|Long|null} [ltt] Tick ltt
             * @property {number|null} [price] Tick price
             * @property {number|null} [prevClose] Tick prevClose
             * @property {number|null} [absoluteChange] Tick absoluteChange
             * @property {string|null} [livePriceColor] Tick livePriceColor
             * @property {number|null} [percentageChange] Tick percentageChange
             * @property {string|null} [changeIdentifier] Tick changeIdentifier
             * @property {number|Long|null} [receivedTs] Tick receivedTs
             * @property {number|Long|null} [volume] Tick volume
             */

            /**
             * Constructs a new Tick.
             * @memberof apidata.prices
             * @classdesc Represents a Tick.
             * @implements ITick
             * @constructor
             * @param {apidata.prices.ITick=} [properties] Properties to set
             */
            function Tick(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Tick entityId.
             * @member {string} entityId
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.entityId = "";

            /**
             * Tick exchange.
             * @member {string} exchange
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.exchange = "";

            /**
             * Tick segment.
             * @member {string} segment
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.segment = "";

            /**
             * Tick ltt.
             * @member {number|Long} ltt
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.ltt = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Tick price.
             * @member {number} price
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.price = 0;

            /**
             * Tick prevClose.
             * @member {number} prevClose
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.prevClose = 0;

            /**
             * Tick absoluteChange.
             * @member {number} absoluteChange
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.absoluteChange = 0;

            /**
             * Tick livePriceColor.
             * @member {string} livePriceColor
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.livePriceColor = "";

            /**
             * Tick percentageChange.
             * @member {number} percentageChange
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.percentageChange = 0;

            /**
             * Tick changeIdentifier.
             * @member {string} changeIdentifier
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.changeIdentifier = "";

            /**
             * Tick receivedTs.
             * @member {number|Long} receivedTs
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.receivedTs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Tick volume.
             * @member {number|Long} volume
             * @memberof apidata.prices.Tick
             * @instance
             */
            Tick.prototype.volume = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * Creates a new Tick instance using the specified properties.
             * @function create
             * @memberof apidata.prices.Tick
             * @static
             * @param {apidata.prices.ITick=} [properties] Properties to set
             * @returns {apidata.prices.Tick} Tick instance
             */
            Tick.create = function create(properties) {
                return new Tick(properties);
            };

            /**
             * Encodes the specified Tick message. Does not implicitly {@link apidata.prices.Tick.verify|verify} messages.
             * @function encode
             * @memberof apidata.prices.Tick
             * @static
             * @param {apidata.prices.ITick} message Tick message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Tick.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.entityId != null && Object.hasOwnProperty.call(message, "entityId"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.entityId);
                if (message.exchange != null && Object.hasOwnProperty.call(message, "exchange"))
                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.exchange);
                if (message.segment != null && Object.hasOwnProperty.call(message, "segment"))
                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.segment);
                if (message.ltt != null && Object.hasOwnProperty.call(message, "ltt"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ltt);
                if (message.price != null && Object.hasOwnProperty.call(message, "price"))
                    writer.uint32(/* id 5, wireType 1 =*/41).double(message.price);
                if (message.prevClose != null && Object.hasOwnProperty.call(message, "prevClose"))
                    writer.uint32(/* id 6, wireType 1 =*/49).double(message.prevClose);
                if (message.absoluteChange != null && Object.hasOwnProperty.call(message, "absoluteChange"))
                    writer.uint32(/* id 7, wireType 1 =*/57).double(message.absoluteChange);
                if (message.livePriceColor != null && Object.hasOwnProperty.call(message, "livePriceColor"))
                    writer.uint32(/* id 8, wireType 2 =*/66).string(message.livePriceColor);
                if (message.percentageChange != null && Object.hasOwnProperty.call(message, "percentageChange"))
                    writer.uint32(/* id 9, wireType 1 =*/73).double(message.percentageChange);
                if (message.changeIdentifier != null && Object.hasOwnProperty.call(message, "changeIdentifier"))
                    writer.uint32(/* id 10, wireType 2 =*/82).string(message.changeIdentifier);
                if (message.receivedTs != null && Object.hasOwnProperty.call(message, "receivedTs"))
                    writer.uint32(/* id 11, wireType 0 =*/88).int64(message.receivedTs);
                if (message.volume != null && Object.hasOwnProperty.call(message, "volume"))
                    writer.uint32(/* id 12, wireType 0 =*/96).int64(message.volume);
                return writer;
            };

            /**
             * Encodes the specified Tick message, length delimited. Does not implicitly {@link apidata.prices.Tick.verify|verify} messages.
             * @function encodeDelimited
             * @memberof apidata.prices.Tick
             * @static
             * @param {apidata.prices.ITick} message Tick message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Tick.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Tick message from the specified reader or buffer.
             * @function decode
             * @memberof apidata.prices.Tick
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {apidata.prices.Tick} Tick
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Tick.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.apidata.prices.Tick();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.entityId = reader.string();
                            break;
                        }
                    case 2: {
                            message.exchange = reader.string();
                            break;
                        }
                    case 3: {
                            message.segment = reader.string();
                            break;
                        }
                    case 4: {
                            message.ltt = reader.int64();
                            break;
                        }
                    case 5: {
                            message.price = reader.double();
                            break;
                        }
                    case 6: {
                            message.prevClose = reader.double();
                            break;
                        }
                    case 7: {
                            message.absoluteChange = reader.double();
                            break;
                        }
                    case 8: {
                            message.livePriceColor = reader.string();
                            break;
                        }
                    case 9: {
                            message.percentageChange = reader.double();
                            break;
                        }
                    case 10: {
                            message.changeIdentifier = reader.string();
                            break;
                        }
                    case 11: {
                            message.receivedTs = reader.int64();
                            break;
                        }
                    case 12: {
                            message.volume = reader.int64();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Tick message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof apidata.prices.Tick
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {apidata.prices.Tick} Tick
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Tick.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Tick message.
             * @function verify
             * @memberof apidata.prices.Tick
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Tick.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.entityId != null && message.hasOwnProperty("entityId"))
                    if (!$util.isString(message.entityId))
                        return "entityId: string expected";
                if (message.exchange != null && message.hasOwnProperty("exchange"))
                    if (!$util.isString(message.exchange))
                        return "exchange: string expected";
                if (message.segment != null && message.hasOwnProperty("segment"))
                    if (!$util.isString(message.segment))
                        return "segment: string expected";
                if (message.ltt != null && message.hasOwnProperty("ltt"))
                    if (!$util.isInteger(message.ltt) && !(message.ltt && $util.isInteger(message.ltt.low) && $util.isInteger(message.ltt.high)))
                        return "ltt: integer|Long expected";
                if (message.price != null && message.hasOwnProperty("price"))
                    if (typeof message.price !== "number")
                        return "price: number expected";
                if (message.prevClose != null && message.hasOwnProperty("prevClose"))
                    if (typeof message.prevClose !== "number")
                        return "prevClose: number expected";
                if (message.absoluteChange != null && message.hasOwnProperty("absoluteChange"))
                    if (typeof message.absoluteChange !== "number")
                        return "absoluteChange: number expected";
                if (message.livePriceColor != null && message.hasOwnProperty("livePriceColor"))
                    if (!$util.isString(message.livePriceColor))
                        return "livePriceColor: string expected";
                if (message.percentageChange != null && message.hasOwnProperty("percentageChange"))
                    if (typeof message.percentageChange !== "number")
                        return "percentageChange: number expected";
                if (message.changeIdentifier != null && message.hasOwnProperty("changeIdentifier"))
                    if (!$util.isString(message.changeIdentifier))
                        return "changeIdentifier: string expected";
                if (message.receivedTs != null && message.hasOwnProperty("receivedTs"))
                    if (!$util.isInteger(message.receivedTs) && !(message.receivedTs && $util.isInteger(message.receivedTs.low) && $util.isInteger(message.receivedTs.high)))
                        return "receivedTs: integer|Long expected";
                if (message.volume != null && message.hasOwnProperty("volume"))
                    if (!$util.isInteger(message.volume) && !(message.volume && $util.isInteger(message.volume.low) && $util.isInteger(message.volume.high)))
                        return "volume: integer|Long expected";
                return null;
            };

            /**
             * Creates a Tick message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof apidata.prices.Tick
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {apidata.prices.Tick} Tick
             */
            Tick.fromObject = function fromObject(object) {
                if (object instanceof $root.apidata.prices.Tick)
                    return object;
                let message = new $root.apidata.prices.Tick();
                if (object.entityId != null)
                    message.entityId = String(object.entityId);
                if (object.exchange != null)
                    message.exchange = String(object.exchange);
                if (object.segment != null)
                    message.segment = String(object.segment);
                if (object.ltt != null)
                    if ($util.Long)
                        (message.ltt = $util.Long.fromValue(object.ltt)).unsigned = false;
                    else if (typeof object.ltt === "string")
                        message.ltt = parseInt(object.ltt, 10);
                    else if (typeof object.ltt === "number")
                        message.ltt = object.ltt;
                    else if (typeof object.ltt === "object")
                        message.ltt = new $util.LongBits(object.ltt.low >>> 0, object.ltt.high >>> 0).toNumber();
                if (object.price != null)
                    message.price = Number(object.price);
                if (object.prevClose != null)
                    message.prevClose = Number(object.prevClose);
                if (object.absoluteChange != null)
                    message.absoluteChange = Number(object.absoluteChange);
                if (object.livePriceColor != null)
                    message.livePriceColor = String(object.livePriceColor);
                if (object.percentageChange != null)
                    message.percentageChange = Number(object.percentageChange);
                if (object.changeIdentifier != null)
                    message.changeIdentifier = String(object.changeIdentifier);
                if (object.receivedTs != null)
                    if ($util.Long)
                        (message.receivedTs = $util.Long.fromValue(object.receivedTs)).unsigned = false;
                    else if (typeof object.receivedTs === "string")
                        message.receivedTs = parseInt(object.receivedTs, 10);
                    else if (typeof object.receivedTs === "number")
                        message.receivedTs = object.receivedTs;
                    else if (typeof object.receivedTs === "object")
                        message.receivedTs = new $util.LongBits(object.receivedTs.low >>> 0, object.receivedTs.high >>> 0).toNumber();
                if (object.volume != null)
                    if ($util.Long)
                        (message.volume = $util.Long.fromValue(object.volume)).unsigned = false;
                    else if (typeof object.volume === "string")
                        message.volume = parseInt(object.volume, 10);
                    else if (typeof object.volume === "number")
                        message.volume = object.volume;
                    else if (typeof object.volume === "object")
                        message.volume = new $util.LongBits(object.volume.low >>> 0, object.volume.high >>> 0).toNumber();
                return message;
            };

            /**
             * Creates a plain object from a Tick message. Also converts values to other types if specified.
             * @function toObject
             * @memberof apidata.prices.Tick
             * @static
             * @param {apidata.prices.Tick} message Tick
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Tick.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.entityId = "";
                    object.exchange = "";
                    object.segment = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.ltt = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.ltt = options.longs === String ? "0" : 0;
                    object.price = 0;
                    object.prevClose = 0;
                    object.absoluteChange = 0;
                    object.livePriceColor = "";
                    object.percentageChange = 0;
                    object.changeIdentifier = "";
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.receivedTs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.receivedTs = options.longs === String ? "0" : 0;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.volume = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.volume = options.longs === String ? "0" : 0;
                }
                if (message.entityId != null && message.hasOwnProperty("entityId"))
                    object.entityId = message.entityId;
                if (message.exchange != null && message.hasOwnProperty("exchange"))
                    object.exchange = message.exchange;
                if (message.segment != null && message.hasOwnProperty("segment"))
                    object.segment = message.segment;
                if (message.ltt != null && message.hasOwnProperty("ltt"))
                    if (typeof message.ltt === "number")
                        object.ltt = options.longs === String ? String(message.ltt) : message.ltt;
                    else
                        object.ltt = options.longs === String ? $util.Long.prototype.toString.call(message.ltt) : options.longs === Number ? new $util.LongBits(message.ltt.low >>> 0, message.ltt.high >>> 0).toNumber() : message.ltt;
                if (message.price != null && message.hasOwnProperty("price"))
                    object.price = options.json && !isFinite(message.price) ? String(message.price) : message.price;
                if (message.prevClose != null && message.hasOwnProperty("prevClose"))
                    object.prevClose = options.json && !isFinite(message.prevClose) ? String(message.prevClose) : message.prevClose;
                if (message.absoluteChange != null && message.hasOwnProperty("absoluteChange"))
                    object.absoluteChange = options.json && !isFinite(message.absoluteChange) ? String(message.absoluteChange) : message.absoluteChange;
                if (message.livePriceColor != null && message.hasOwnProperty("livePriceColor"))
                    object.livePriceColor = message.livePriceColor;
                if (message.percentageChange != null && message.hasOwnProperty("percentageChange"))
                    object.percentageChange = options.json && !isFinite(message.percentageChange) ? String(message.percentageChange) : message.percentageChange;
                if (message.changeIdentifier != null && message.hasOwnProperty("changeIdentifier"))
                    object.changeIdentifier = message.changeIdentifier;
                if (message.receivedTs != null && message.hasOwnProperty("receivedTs"))
                    if (typeof message.receivedTs === "number")
                        object.receivedTs = options.longs === String ? String(message.receivedTs) : message.receivedTs;
                    else
                        object.receivedTs = options.longs === String ? $util.Long.prototype.toString.call(message.receivedTs) : options.longs === Number ? new $util.LongBits(message.receivedTs.low >>> 0, message.receivedTs.high >>> 0).toNumber() : message.receivedTs;
                if (message.volume != null && message.hasOwnProperty("volume"))
                    if (typeof message.volume === "number")
                        object.volume = options.longs === String ? String(message.volume) : message.volume;
                    else
                        object.volume = options.longs === String ? $util.Long.prototype.toString.call(message.volume) : options.longs === Number ? new $util.LongBits(message.volume.low >>> 0, message.volume.high >>> 0).toNumber() : message.volume;
                return object;
            };

            /**
             * Converts this Tick to JSON.
             * @function toJSON
             * @memberof apidata.prices.Tick
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Tick.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for Tick
             * @function getTypeUrl
             * @memberof apidata.prices.Tick
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            Tick.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/apidata.prices.Tick";
            };

            return Tick;
        })();

        prices.PriceData = (function() {

            /**
             * Properties of a PriceData.
             * @memberof apidata.prices
             * @interface IPriceData
             * @property {string|null} [mode] PriceData mode
             * @property {apidata.prices.ITick|null} [tick] PriceData tick
             * @property {number|Long|null} [sentTs] PriceData sentTs
             * @property {string|null} [subPath] PriceData subPath
             */

            /**
             * Constructs a new PriceData.
             * @memberof apidata.prices
             * @classdesc Represents a PriceData.
             * @implements IPriceData
             * @constructor
             * @param {apidata.prices.IPriceData=} [properties] Properties to set
             */
            function PriceData(properties) {
                if (properties)
                    for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * PriceData mode.
             * @member {string} mode
             * @memberof apidata.prices.PriceData
             * @instance
             */
            PriceData.prototype.mode = "";

            /**
             * PriceData tick.
             * @member {apidata.prices.ITick|null|undefined} tick
             * @memberof apidata.prices.PriceData
             * @instance
             */
            PriceData.prototype.tick = null;

            /**
             * PriceData sentTs.
             * @member {number|Long} sentTs
             * @memberof apidata.prices.PriceData
             * @instance
             */
            PriceData.prototype.sentTs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

            /**
             * PriceData subPath.
             * @member {string} subPath
             * @memberof apidata.prices.PriceData
             * @instance
             */
            PriceData.prototype.subPath = "";

            /**
             * Creates a new PriceData instance using the specified properties.
             * @function create
             * @memberof apidata.prices.PriceData
             * @static
             * @param {apidata.prices.IPriceData=} [properties] Properties to set
             * @returns {apidata.prices.PriceData} PriceData instance
             */
            PriceData.create = function create(properties) {
                return new PriceData(properties);
            };

            /**
             * Encodes the specified PriceData message. Does not implicitly {@link apidata.prices.PriceData.verify|verify} messages.
             * @function encode
             * @memberof apidata.prices.PriceData
             * @static
             * @param {apidata.prices.IPriceData} message PriceData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PriceData.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.mode);
                if (message.tick != null && Object.hasOwnProperty.call(message, "tick"))
                    $root.apidata.prices.Tick.encode(message.tick, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                if (message.sentTs != null && Object.hasOwnProperty.call(message, "sentTs"))
                    writer.uint32(/* id 4, wireType 0 =*/32).int64(message.sentTs);
                if (message.subPath != null && Object.hasOwnProperty.call(message, "subPath"))
                    writer.uint32(/* id 5, wireType 2 =*/42).string(message.subPath);
                return writer;
            };

            /**
             * Encodes the specified PriceData message, length delimited. Does not implicitly {@link apidata.prices.PriceData.verify|verify} messages.
             * @function encodeDelimited
             * @memberof apidata.prices.PriceData
             * @static
             * @param {apidata.prices.IPriceData} message PriceData message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            PriceData.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a PriceData message from the specified reader or buffer.
             * @function decode
             * @memberof apidata.prices.PriceData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {apidata.prices.PriceData} PriceData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PriceData.decode = function decode(reader, length, error) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                let end = length === undefined ? reader.len : reader.pos + length, message = new $root.apidata.prices.PriceData();
                while (reader.pos < end) {
                    let tag = reader.uint32();
                    if (tag === error)
                        break;
                    switch (tag >>> 3) {
                    case 1: {
                            message.mode = reader.string();
                            break;
                        }
                    case 2: {
                            message.tick = $root.apidata.prices.Tick.decode(reader, reader.uint32());
                            break;
                        }
                    case 4: {
                            message.sentTs = reader.int64();
                            break;
                        }
                    case 5: {
                            message.subPath = reader.string();
                            break;
                        }
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a PriceData message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof apidata.prices.PriceData
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {apidata.prices.PriceData} PriceData
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            PriceData.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a PriceData message.
             * @function verify
             * @memberof apidata.prices.PriceData
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            PriceData.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.mode != null && message.hasOwnProperty("mode"))
                    if (!$util.isString(message.mode))
                        return "mode: string expected";
                if (message.tick != null && message.hasOwnProperty("tick")) {
                    let error = $root.apidata.prices.Tick.verify(message.tick);
                    if (error)
                        return "tick." + error;
                }
                if (message.sentTs != null && message.hasOwnProperty("sentTs"))
                    if (!$util.isInteger(message.sentTs) && !(message.sentTs && $util.isInteger(message.sentTs.low) && $util.isInteger(message.sentTs.high)))
                        return "sentTs: integer|Long expected";
                if (message.subPath != null && message.hasOwnProperty("subPath"))
                    if (!$util.isString(message.subPath))
                        return "subPath: string expected";
                return null;
            };

            /**
             * Creates a PriceData message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof apidata.prices.PriceData
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {apidata.prices.PriceData} PriceData
             */
            PriceData.fromObject = function fromObject(object) {
                if (object instanceof $root.apidata.prices.PriceData)
                    return object;
                let message = new $root.apidata.prices.PriceData();
                if (object.mode != null)
                    message.mode = String(object.mode);
                if (object.tick != null) {
                    if (typeof object.tick !== "object")
                        throw TypeError(".apidata.prices.PriceData.tick: object expected");
                    message.tick = $root.apidata.prices.Tick.fromObject(object.tick);
                }
                if (object.sentTs != null)
                    if ($util.Long)
                        (message.sentTs = $util.Long.fromValue(object.sentTs)).unsigned = false;
                    else if (typeof object.sentTs === "string")
                        message.sentTs = parseInt(object.sentTs, 10);
                    else if (typeof object.sentTs === "number")
                        message.sentTs = object.sentTs;
                    else if (typeof object.sentTs === "object")
                        message.sentTs = new $util.LongBits(object.sentTs.low >>> 0, object.sentTs.high >>> 0).toNumber();
                if (object.subPath != null)
                    message.subPath = String(object.subPath);
                return message;
            };

            /**
             * Creates a plain object from a PriceData message. Also converts values to other types if specified.
             * @function toObject
             * @memberof apidata.prices.PriceData
             * @static
             * @param {apidata.prices.PriceData} message PriceData
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            PriceData.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                let object = {};
                if (options.defaults) {
                    object.mode = "";
                    object.tick = null;
                    if ($util.Long) {
                        let long = new $util.Long(0, 0, false);
                        object.sentTs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                    } else
                        object.sentTs = options.longs === String ? "0" : 0;
                    object.subPath = "";
                }
                if (message.mode != null && message.hasOwnProperty("mode"))
                    object.mode = message.mode;
                if (message.tick != null && message.hasOwnProperty("tick"))
                    object.tick = $root.apidata.prices.Tick.toObject(message.tick, options);
                if (message.sentTs != null && message.hasOwnProperty("sentTs"))
                    if (typeof message.sentTs === "number")
                        object.sentTs = options.longs === String ? String(message.sentTs) : message.sentTs;
                    else
                        object.sentTs = options.longs === String ? $util.Long.prototype.toString.call(message.sentTs) : options.longs === Number ? new $util.LongBits(message.sentTs.low >>> 0, message.sentTs.high >>> 0).toNumber() : message.sentTs;
                if (message.subPath != null && message.hasOwnProperty("subPath"))
                    object.subPath = message.subPath;
                return object;
            };

            /**
             * Converts this PriceData to JSON.
             * @function toJSON
             * @memberof apidata.prices.PriceData
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            PriceData.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            /**
             * Gets the default type url for PriceData
             * @function getTypeUrl
             * @memberof apidata.prices.PriceData
             * @static
             * @param {string} [typeUrlPrefix] your custom typeUrlPrefix(default "type.googleapis.com")
             * @returns {string} The default type url
             */
            PriceData.getTypeUrl = function getTypeUrl(typeUrlPrefix) {
                if (typeUrlPrefix === undefined) {
                    typeUrlPrefix = "type.googleapis.com";
                }
                return typeUrlPrefix + "/apidata.prices.PriceData";
            };

            return PriceData;
        })();

        return prices;
    })();

    return apidata;
})();

export { $root as default };
